let fontSizesArray = [6, 8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96];

export const fontSizes = fontSizesArray;

let lineHeightArray = [];
const maxLineSpace = 2.5;
let i = 1;
while (i <= maxLineSpace) {
  lineHeightArray.push(i.toFixed(1));
  i = parseFloat((i + 0.1).toFixed(1));
}
export const lineHeights = lineHeightArray;
